export const transition = '0.05s ease-in-out'

export default transition
